import PropTypes from 'prop-types';
import { Alert, Col, Row } from 'react-bootstrap';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function Message(_ref) {
  var onClose = _ref.onClose,
      variant = _ref.variant,
      icon = _ref.icon,
      children = _ref.children;
  var IconCmp = icon;
  return /*#__PURE__*/_jsx(Alert, {
    variant: variant,
    dismissible: true,
    onClose: onClose,
    children: /*#__PURE__*/_jsxs(Row, {
      children: [/*#__PURE__*/_jsxs(Col, {
        xs: "x",
        className: "my-auto",
        children: [" ", /*#__PURE__*/_jsx(IconCmp, {
          className: "ml-2 h4 my-0"
        })]
      }), /*#__PURE__*/_jsx(Col, {
        children: children
      })]
    })
  });
}
Message.propTypes = {
  onClose: PropTypes.func,
  variant: PropTypes.string.isRequired,
  icon: PropTypes.object.isRequired,
  children: PropTypes.any
};
Message.defaultProps = {
  onClose: null,
  children: null
};